import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { Paper } from '@material-ui/core';
import { instanceAxios } from '../../InstanceAxios';

function getAcessos(perfil) {
  return Array.isArray(perfil?.Acessos) ? perfil.Acessos : [];
}

function Acessos() {
  const [perfis, setPerfis] = useState([]);
  const [perfilSelecionado, setPerfilSelecionado] = useState(null);
  const [menus, setMenus] = useState([]);
  const [checked, setChecked] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchPerfis = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/perfil`)
        .then((res) => {
          setPerfis(Array.isArray(res?.data) ? res.data : []);
        })
        .catch((err) => {
          console.log(err);
          setAlertType('error');
          setMessage('Erro ao carregar os perfis,tente novamente mais tarde!');
          setAlert(true);
        });
    };
    const fetchMenus = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/menu`)
        .then((res) => {
          setMenus(Array.isArray(res?.data) ? res.data : []);
        })
        .catch((err) => {
          console.log(err);
          setAlertType('error');
          setMessage(
            'Erro ao carregar os Funcionalidades,tente novamente mais tarde!'
          );
          setAlert(true);
        });
    };

    fetchPerfis();
    fetchMenus();
  }, []);

  return (
    <div style={{ margin: 20 }}>
      <Collapse in={alert}>
        <Alert severity={alertType} onClick={() => setAlert(false)}>
          {message}
        </Alert>
      </Collapse>
      <h1 style={{ textAlign: 'center' }}>Acessos</h1>
      <Grid container spacing={3} style={{ paddingTop: '1%' }}>
        <Grid item xs={6}>
          <Paper elevation={5} style={{ padding: 5 }}>
            <h2 style={{ fontSize: '1.2em' }}>Perfis</h2>
            <List>
              {perfis.map((p) => (
                <ListItem
                  button
                  onClick={() => {
                    const checkedLocal = [];
                    getAcessos(p).forEach((a) => checkedLocal.push(a.id_menu));
                    setChecked(checkedLocal);
                    setPerfilSelecionado(p);
                  }}
                >
                  <ListItemText primary={p.nome} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={6}>
          <Paper elevation={5} style={{ padding: 5 }}>
            <h2 style={{ fontSize: '1.2em' }}>Funcionalidades</h2>
            <FormControl component="fieldset">
              <FormGroup>
                {menus.map((m) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked.includes(m.id)}
                        onChange={async (event, value) => {
                          if (!perfilSelecionado?.id) {
                            setAlertType('warning');
                            setMessage(
                              'Selecione um perfil antes de vincular acessos.'
                            );
                            setAlert(true);
                            return;
                          }

                          console.log(value);
                          if (value) {
                            await instanceAxios(
                              localStorage.getItem('toobiauth')
                            )
                              .post(`/acesso`, {
                                id_menu: m.id,
                                id_perfil: perfilSelecionado.id,
                              })
                              .then((res) => {
                                setAlertType('success');
                                setMessage(
                                  'Funcionalidade Vinculada com Sucesso!'
                                );
                                setAlert(true);
                                const ps = {
                                  ...perfilSelecionado,
                                  Acessos: [
                                    ...getAcessos(perfilSelecionado),
                                    res.data,
                                  ],
                                };
                                setPerfilSelecionado(ps);
                                setChecked(ps.Acessos.map((a) => a.id_menu));
                                setPerfis((currentPerfis) =>
                                  currentPerfis.map((pf) =>
                                    pf.id === ps.id ? ps : pf
                                  )
                                );
                              })
                              .catch((err) => {
                                console.log(err);
                                setAlertType('error');
                                setMessage('Erro ao Vincular Funcionalidade!');
                                setAlert(true);
                              });
                          } else {
                            await instanceAxios(
                              localStorage.getItem('toobiauth')
                            )
                              .delete(`/acesso/${perfilSelecionado.id}/${m.id}`)
                              .then((res) => {
                                setAlertType('success');
                                setMessage(
                                  'Funcionalidade Desvinculada com Sucesso!'
                                );
                                setAlert(true);
                                const ps = {
                                  ...perfilSelecionado,
                                  Acessos: getAcessos(perfilSelecionado).filter(
                                    (acesso) => acesso.id_menu !== m.id
                                  ),
                                };
                                setPerfilSelecionado(ps);
                                setChecked(ps.Acessos.map((a) => a.id_menu));
                                setPerfis((currentPerfis) =>
                                  currentPerfis.map((pf) =>
                                    pf.id === ps.id ? ps : pf
                                  )
                                );
                              })
                              .catch((err) => {
                                console.log(err);
                                setAlertType('error');
                                setMessage('Erro ao Vincular Funcionalidade!');
                                setAlert(true);
                              });
                          }
                        }}
                      />
                    }
                    label={m.nome}
                  />
                ))}
              </FormGroup>
              <FormHelperText>Vincule o acesso com o Perfil</FormHelperText>
            </FormControl>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default Acessos;
